import {
  LOGOUT,
  LOGIN,
  SET_OWNER_ID,
  SET_USER_NAME,
  SET_INKIND_ID,
  SET_INKIND_ROUTE_ID,
  SET_TIMEZONE,
  SET_CALENDAR_TIMEZONE,
  SET_CALENDAR_TIMEZONE_DISPLAY,
  SET_RECIPIENT_CONTACT_INFORMATION,
  SET_IS_FOLLOWING_INKIND,
  SET_INKIND_TITLE,
  SET_INKIND_PAGE_THUMBNAIL_SMALL,
} from '../actions/session';

export function getUserType(userId, ownerId) {
  let userType = 'passive';
  if (userId === ownerId || window.__root.isOrganizer === true || window.__root.isOrganizer === 'true') {
    userType = 'organizer';
  } else {
    if (userId) userType = 'participant';
  }
  return userType;
}

export default function sessionReducer(
  state: any = {
    username: '',
  },
  action: any
) {
  let userType;
  const store = require('app').store;

  switch (action.type) {
    case LOGOUT:
      return {};
    case SET_TIMEZONE:
      return { ...state, timezone: action.timezone };
    case SET_RECIPIENT_CONTACT_INFORMATION:
      return { ...state, recipientContactInformation: action.recipientContactInformation };
    case SET_CALENDAR_TIMEZONE:
      return { ...state, calendarTimezone: action.calendarTimezone };
    case SET_CALENDAR_TIMEZONE_DISPLAY:
      return { ...state, calendarTimezoneDisplay: action.display };
    case SET_INKIND_ID:
      userType = getUserType(state.userId, state.ownerId);
      return { ...state, inkindId: action.id, userType };
    case SET_INKIND_ROUTE_ID:
      return { ...state, inkindRouteId: action.routeId };
    case SET_OWNER_ID:
      userType = getUserType(state.userId, action.id);
      return { ...state, ownerId: action.id, userType };
    case SET_USER_NAME:
      return { ...state, userFirstName: action.userFirstName, userLastName: action.userLastName };
    case SET_IS_FOLLOWING_INKIND:
      return { ...state, isFollowingInkind: action.isFollowingInkind };
    case SET_INKIND_PAGE_THUMBNAIL_SMALL:
      return { ...state, inkindPageThumbnailSmall: action.inkindPageThumbnailSmall };
    case SET_INKIND_TITLE:
      return { ...state, inkindTitle: action.inkindTitle };
    case LOGIN:
      userType = getUserType(action.userId, state.ownerId);
      return { ...state, userId: action.userId, userType };
    default:
      return state;
  }
}
